import React from 'react';

import { Typography } from '@mui/material';
import RoundedBox from 'app/shared/componentsRestyled/common/RoundedBox';
import FormGeneratorSwitchCDS from 'app/shared/componentsRestyled/coreDesignSystem/formGenerator/FormGeneratorSwitchCDS';
import PropTypes from 'prop-types';

const SignatureOptions = ({ displaySignatureLine, usePoaVerbiage, onChange }) => (
  <div className="flex flex-col gap-8">
    <Typography color="text.secondary" variant="bold12">
      Signature options
    </Typography>
    <RoundedBox className="flex flex-col gap-12 min-w-[358px]">
      <FormGeneratorSwitchCDS
        checked={displaySignatureLine}
        label="Display signature line"
        name="displaySignatureLine"
        onChange={onChange}
      />
      {displaySignatureLine && (
        <FormGeneratorSwitchCDS
          checked={usePoaVerbiage}
          label="Use POA verbiage"
          name="usePoaVerbiage"
          onChange={onChange}
        />
      )}
    </RoundedBox>
  </div>
);

SignatureOptions.propTypes = {
  displaySignatureLine: PropTypes.bool.isRequired,
  usePoaVerbiage: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SignatureOptions;
